import { useQueryClient } from '@tanstack/react-query';
import { toast } from '@/components/ui/helpers/toast';

import { useAuthenticatedMutation } from '@/hooks/auth/use-auth-query-hooks';
import { invalidateRelatedQueries } from '@/lib/query/cache-invalidation';
import { AccountsApiService } from '@/services/internal-api/accounts/accounts-api-service';

interface ResendInviteParams {
  accountId: string;
  email: string;
  role: string;
}

export function useResendInvite() {
  const queryClient = useQueryClient();

  return useAuthenticatedMutation({
    mutationFn: async ({ accountId, email, role }: ResendInviteParams) => {
      const response = await AccountsApiService.inviteUser(accountId, email, role);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      toast.success('The invitation has been resent successfully.');
      invalidateRelatedQueries(queryClient, 'TEAM_MEMBERS', { refetchType: 'active' });
      void queryClient.invalidateQueries({
        queryKey: ['teamMembers', variables.accountId],
        refetchType: 'active',
      });
    },
    onError: (error: any) => {
      console.error('Error resending invitation:', error);
      toast.error(error?.response?.data?.message || 'Failed to resend invitation.');
    },
  });
}
